import React, { useState } from 'react';
import CircleButton, {
  getCircleButtonClass,
} from 'components/v2/buttons/CircleButton';
import CargomaticTooltip from 'components/v2/Tooltip';
import { DocumentCheckIcon } from '@heroicons/react/24/solid';
import CheckIcon from 'components/v2/icons/CheckIcon';
import { useTranslation } from 'react-i18next';
import StopArrivedModal from 'components/modules/shipments/stops/StopArrivedModal';
import ShipmentsActionCreators from 'actions/ShipmentsActionCreators';

export default function StopArrivalNextStep({ item, shipment }) {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const { stops } = shipment;
  const stop = stops.find((s) => s._id === item?.meta?.stop);

  const createAction = () => {
    const offsite = stop?.off_site ? '_OFFSITE' : '';
    const empty = stop?.empty ? '_EMPTY' : '';
    const action = stop?.action === 'deliver' ? '_DELIVERY' : '_PICKUP';
    return `COMPLETE${offsite}${empty}${action}_ARRIVAL`;
  };

  const renderIcon = () => {
    return !item.complete ? (
      <DocumentCheckIcon type="solid" className="w-5 h-5" />
    ) : (
      <div
        data-testid="div-902a90ce"
        className={getCircleButtonClass({ size: 'small', color: 'brand' })}>
        <CheckIcon />
      </div>
    );
  };

  const renderArriveButton = (item, stops, shipper) => {
    if (!(item && stops && shipper)) {
      return null;
    }

    const circleButton = (shouldDisable) => (
      <CircleButton
        dataTestId="CircleButton-09a7e3e8"
        size="small"
        disabled={shouldDisable}
        onClick={() => setShowModal(true)}>
        {renderIcon()}
      </CircleButton>
    );

    if (item.complete) {
      return circleButton(true);
    }

    const disabled = !!item.disabled;
    if (disabled) {
      return (
        (<CargomaticTooltip
          dataTestId="CargomaticTooltip-dbfe93b7"
          position="top"
          body={() => circleButton(disabled)}>
          {t('COMPLETE_PREVIOUS_STOPS')}
        </CargomaticTooltip>)
      );
    }
    return circleButton(false);
  };

  return (
    (<div data-testid="div-2e8587b0">
      <div
        data-testid="div-7021fc58"
        className="flex justify-between text-sm text-gray-700  py-1 items-center">
        <span data-testid="span-6a57bdc0">{t(createAction())}</span>
        {renderArriveButton(item, stops, shipment?.shipper)}
      </div>
      {showModal && (
        <StopArrivedModal
          stop={stop}
          shipment={shipment}
          show={showModal}
          onHide={() => setShowModal(false)}
          onStopArrived={ShipmentsActionCreators.transitionStop}
        />
      )}
    </div>)
  );
}
